import { IFormFieldSubmission } from "@common/redux/formSubmission/interface";
import { FieldProps } from "../FormFieldSelector/interfaces";

import {
  ICheckBoxFieldConfigurationClient,
  ICheckBoxFieldConfigurationServer,
} from "./interface";

export const validateCheckBoxFieldSubmissionData = (
  fieldEditConfig: FieldProps,
  fieldSubmissionData: IFormFieldSubmission
): [boolean, string] => {
  const { isRequired, isVisible} = fieldEditConfig;
  const fieldSubmissionValue = fieldSubmissionData?.fieldSubmissionValue;

  const submissionValue =
    (fieldSubmissionValue && fieldSubmissionValue?.checkBoxValue) || "";
  if (isRequired && !!isVisible) {
    if (submissionValue.toLowerCase() !== "true") {
      return [false, "This is a Required Field"];
    }
  }
  return [true, ""];
};

export const transformCheckBoxInputFieldConfigClientToServer = (
  fieldConfigClient: ICheckBoxFieldConfigurationClient
): ICheckBoxFieldConfigurationClient => {
  const { initialValue, writeJavascript } = fieldConfigClient;
  const fieldConfigServer = {
    initialValue: initialValue,
    writeJavascript: writeJavascript,
  };
  return fieldConfigServer;
};

export const transformCheckBoxInputConfigServerToClient = (
  fieldConfigServer: ICheckBoxFieldConfigurationServer
): ICheckBoxFieldConfigurationClient => {
  const { initialValue, writeJavascript } = fieldConfigServer;
  const fieldConfigClient = {
    initialValue: initialValue,
    writeJavascript: writeJavascript,
  };
  return fieldConfigClient;
};
